import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import ClaimsActivity from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivity";

export const ClaimsActivityRouter: React.FC<React.PropsWithChildren<RouteComponentProps>> = (props: RouteComponentProps) => {
  return (
    <Switch>
      <Route exact={true} path={`${props.match.path}`} component={ClaimsActivity} />

      <Route component={NotFound} />
    </Switch>
  );
}